import { styled } from '@mui/material/styles';
import { Typography, ButtonGroup, Button } from '@mui/material';
import { grey, isDark } from 'global/styles';

export const DrContainer = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const SmallMarginTopBottom = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const DrFilters = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  '@media print': {
    display: 'none',
  },
  '&> :first-child': {
    marginRight: theme.spacing(2),
  },
  '&> div': {
    minWidth: theme.spacing(10),
  },
  [theme.breakpoints.down('lg')]: {
    marginLeft: theme.spacing(2),
    marginTop: theme.spacing(2),
  },

  '& .MuiFormLabel-root': {
    left: -14,
  },
}));

export const Overline = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1),
}));

export const FilterCol = styled('div')(({ theme }) => ({
  borderRadius: 5,
  padding: theme.spacing(1),
  paddingTop: theme.spacing(0.5),
  marginTop: theme.spacing(2),
}));

export const DrButtonGroup = styled(ButtonGroup)(({ theme }) => ({
  margin: theme.spacing(0.25),

  '& .MuiButton-contained.Mui-disabled': {
    backgroundColor: isDark(theme) ? grey(theme, 600) : grey(theme, 100),
    color: theme.palette.action.disabled,
  },

  '& .MuiButton-contained': {
    backgroundColor: isDark(theme) ? grey(theme, 700) : grey(theme, 300),
    color: theme.palette.getContrastText(isDark(theme) ? grey(theme, 700) : grey(theme, 300)),
    borderColor: isDark(theme) ? `${theme.palette.background.paper} !important` : grey(theme, 400),

    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}));

export const DrFilterButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})(({ theme, isActive }) => ({
  ...(isActive && {
    '&.MuiButton-contained': {
      backgroundColor: isDark(theme) ? grey(theme, 800) : grey(theme, 500),
    },
  }),
}));

export const ChartWrap = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
});
